import Menu from "../../../../components/Menu/Menu";

export default function PartyFun() {
    return (
        <div id='party-fun'>
            <div className='centered-container'>
                <Menu title="Party Fun" options={[
                    { name: 'One device', path: '/misc/minigames/partyfun' },
                    { name: 'Multiple devices', path: '/misc/minigames/partyfun?multidevices=true' },
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    )
}